'use strict';

export default value => {
  let display = '';

  if (value === 0) {
    display = 'E';
  } else if (value === null || value === undefined) {
    display = '';
  } else {
    display = value;
  }
  return display;
};
